<div class="d-flex h-100 py-3">
  <div class="flex-grow-1 d-flex flex-column">
    <div class="px-3 mb-3">
      <ng-content select="[slot=header]"></ng-content>
    </div>

    <div class="flex-grow-1 px-3 d-flex flex-column">
      <div class="px-3 mb-5 d-flex justify-content-center">
        <img class="logo" [src]="logoUrl()" alt="Insolution" />
      </div>

      <div class="px-3 mb-5">
        <ng-content select="[slot=main]"></ng-content>
      </div>
    </div>

    <div class="px-3">
      <ng-content select="[slot=footer]"></ng-content>
    </div>
  </div>
</div>
